import React from "react";
import './App.scss';

function NextButton() {
  return (
    <button className="nextButton">
      다음 &gt;
    </button>
  )
}

export default NextButton;